<template>
  <section id="dlaczego-my" class="bg-graphite-900 py-20 sm:py-28">
    <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div class="mx-auto max-w-2xl text-center">
        <span class="inline-flex items-center border-l-4 border-brand-500 pl-3 text-xs font-bold uppercase tracking-[0.2em] text-brand-400">Dlaczego my</span>
        <h2 class="mt-4 text-3xl font-black tracking-tight text-white sm:text-4xl">
          Park maszynowy, jakość i terminowość, na których można polegać
        </h2>
        <p class="mt-5 text-base leading-relaxed text-graphite-400">
          Inwestujemy w nowoczesny park maszynowy i procedury kontroli jakości, aby każde
          zlecenie trafiało do klienta zgodnie z dokumentacją i ustalonym terminem.
        </p>
      </div>

      <div class="mt-16 grid grid-cols-1 border-l border-t border-white/10 sm:grid-cols-2 lg:grid-cols-4">
        <div v-for="item in advantages" :key="item.title" class="border-b border-r border-white/10 p-7">
          <div class="flex h-11 w-11 items-center justify-center border-2 border-brand-500 text-brand-400" v-html="item.icon"></div>
          <h3 class="mt-5 text-base font-bold text-white">{{ item.title }}</h3>
          <p class="mt-2 text-sm leading-relaxed text-graphite-400">{{ item.text }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'WhyUsSection',
  data() {
    return {
      advantages: [
        {
          title: 'Nowoczesny park maszynowy',
          text: 'Maszyny do cięcia, gięcia i wypalania pozwalające zachować powtarzalność wymiarową.',
          icon: '<svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M11.42 15.17L17.25 21A2.652 2.652 0 0021 17.25l-5.877-5.877M11.42 15.17l2.496-3.03c.317-.384.74-.626 1.208-.766M11.42 15.17l-4.655 5.653a2.548 2.548 0 11-3.586-3.586l6.837-5.63m5.108-.233c.55-.164 1.163-.188 1.743-.14a4.5 4.5 0 004.486-6.336l-3.276 3.277a3.004 3.004 0 01-2.25-2.25l3.276-3.276a4.5 4.5 0 00-6.336 4.486c.091 1.076-.071 2.264-.904 2.95l-.102.085"/></svg>'
        },
        {
          title: 'Dotrzymane terminy',
          text: 'Realny harmonogram produkcji ustalany na starcie zlecenia i konsekwentnie realizowany.',
          icon: '<svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M12 6v6l4 2m6-2a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>'
        },
        {
          title: 'Kontrola jakości',
          text: 'Weryfikacja wymiarów i wykonania na każdym etapie — od cięcia po wykończenie.',
          icon: '<svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>'
        },
        {
          title: 'Jeden partner, pełen zakres',
          text: 'Koordynujemy projekt, produkcję i wykończenie, w tym cynkowanie u sprawdzonego partnera.',
          icon: '<svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M17 20h5v-2a4 4 0 00-3-3.87M9 20H4v-2a4 4 0 013-3.87m6-1.13a4 4 0 100-8 4 4 0 000 8zm6 3.13a4 4 0 00-8 0"/></svg>'
        }
      ]
    };
  }
};
</script>
